export default __webpack_public_path__ + "static/media/freedom-info.751401ee.png";